
// 插件路由
const lottery = () => import(/* webpackChunkName: "lottery" */ '../pages/lottery.vue')

const routes = [
	{ 
        path: '/lottery', 
        component: lottery 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/lottery/router/index.js